import * as React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { SegPInsights } from 'segmentation-widget';

import { isRequestsPending } from 'utils/request-state-utils';
import ProgressiveContainer from 'components/container/ProgressiveContainer';

import { getSegPConfig, GET_SEGP_CONFIG } from 'actions/newTridentExtra';
import { getRequestStateKey } from 'omega-rtc/utils/ucd-utils';

type Props = {
  segmentID: string,
  namespace: string,
  onDataLoaded: Function, // a callback function that takes data as param
};

// SegPInsightsWidget is a wrapper for SegPInsights
class SegPInsightsWidget extends React.Component {
  props: Props;

  constructor(props: Props) {
    super(props);
    this.state = {
      isEmptyInsights: false,
    };
    if (_.isEmpty(props.segPToken)) {
      props.getSegPConfig();
    }
  }

  render() {
    const { segmentID, namespace, segPToken, getSegPConfigRequest } = this.props;

    return (
      <ProgressiveContainer isLoading={isRequestsPending(getSegPConfigRequest)}>
        {
          !_.isEmpty(segPToken) &&
          <div>
            {
              this.state.isEmptyInsights ?
                <p>Segment breakdown is not available for this segment</p>
                :
                <SegPInsights
                  token={segPToken}
                  src={`${window.Grab.config.SEGMENTATION_PLATFORM_URI}/widget/insights`}
                  segmentIdentity={segmentID}
                  namespace={namespace}
                  tabConfig={[
                    { name: 'Default Breakdown', charts: ['country', 'city'] },
                    { name: 'Others', charts: ['gender', 'os'] },
                  ]}
                  onChange={
                    (event) => {
                      this.setState({
                        isEmptyInsights: _.isEmpty(event.data),
                      });
                      if (this.props.onDataLoaded) {
                        this.props.onDataLoaded(event.data);
                      }
                    }
                  }
                />
            }
          </div>
        }
      </ProgressiveContainer>
    );
  }
}

// connect to action of retrieving segp config
function mapStateToProps(state: StoreState) {
  return {
    segPToken: _.get(state, 'newTridents.segPConfig.token', ''),
    getSegPConfigRequest: _.get(
      state.requests,
      getRequestStateKey(GET_SEGP_CONFIG),
      {},
    ),
  };
}

export default connect(mapStateToProps, { getSegPConfig })(SegPInsightsWidget);
